import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import arrowright from "../../../assets/arrowright.svg";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AllVendorsTable = ({ loading, additionalData, pagination, handlePaymentClick }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(() => additionalData || [], [additionalData]);

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const columns = useMemo(
    () => [
      {
        Header: t("Vendor Name"),
        accessor: "name",
        width: "200px",
        Cell: ({ row }) => <div className="text-start">{row.original.name}</div>,
      },
      {
        Header: t("Phone Number"),
        accessor: "phone",
        width: "150px",
        Cell: ({ row }) => <div className="text-start">{row.original.phone}</div>,
      },
      {
        Header: t("Current Inventory Value"),
        accessor: "inventory_value",
        width: "180px",
        Cell: ({ row }) => (
          <div className="text-start">{"EGP"} {row.original.inventory_value?.toFixed(2)}</div>
        ),
      },
      {
        Header: t("Current Inventory in Days"),
        accessor: "inventory_days",
        width: "180px",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.inventory_days}</div>
        ),
      },
      {
        Header: t("Daily sales average value"),
        accessor: "daily_sales_avg_value",
        width: "180px",
        Cell: ({ row }) => (
          <div className="text-start">{"EGP"} {row.original.daily_sales_avg_value?.toFixed(2)}</div>
        ),
      },
      // {
      //   Header: t("Balance Due"),
      //   accessor: "balance_due",
      //   width: "150px",
      //   Cell: ({ row }) => (
      //     <div className="text-start">{"EGP"} {row.original.balance_due}</div>
      //   ),
      // },
      {
        Header: () => (
          <div title={t("Sort")} className="cursor-pointer">
            {t("Balance Due")}
          </div>
        ),
        accessor: "balance_due",
        width: "150px",
        Cell: ({ row }) => (
          <div className="text-start">
            {"EGP"} {row.original.balance_due?.toFixed(2)}
          </div>
        ),
      },

      ...(allStores
        ? [
          {
            Header: t("Store Name"),
            accessor: "store_name",
            width: "200px",
            Cell: ({ row }) => <div className="text-start">{row.original.store_name}</div>,
          },
        ]
        : []),

      {
        Header: () => (
          <div title={t("Sort")} className="cursor-pointer">
            {t("Status")}
          </div>
        ),
        accessor: "pay",
        width: "150px",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.balance_due !== 0 && (
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row click
                  handlePaymentClick(row.original); // Call the handlePaymentClick function
                }}
                className="font-semibold w-20 h-8 border rounded-lg bg-[#7EC242] text-white text-sm flex justify-center items-center gap-2"
                type="submit"
              >
                {t("Pay Now")}
              </button>
            )}
            {row.original.balance_due === 0 && (
              <button
                className="font-semibold w-16 h-8 border rounded-lg bg-[#E8A700] text-white text-sm flex justify-center items-center gap-2"
                type="submit"
              >
                {t("Paid")}
              </button>
            )}
          </div>
        ),
      },
      {
        Header: "",
        accessor: "action",
        width: "100px",
        Cell: ({ row }) => (
          <button
            className="text-[#1b4497] text-start rounded-lg"
            onClick={(e) => {
              e.stopPropagation(); // Prevent row click
              openOrderList(row.original.id);
            }}
          >
            <img
              src={arrowright}
              alt="right"
              className={`${i18n.language === "en" ? "" : "rotate-180"}`}
              height={3}
              width={20}
            />
          </button>
        ),
      },
    ],
    [t, i18n.language]
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);
  console.log('pageSize==>,', data?.length);

  return (
    <div className="container flex flex-col mx-auto mt-4" style={{ maxWidth: "100%" }}>
      {(loading || (additionalData?.length === 0 && !flag)) ? (
        <div className="h-screen w-[90%] mt-2 ">
          <ShimmerLoader />
        </div>
      ) : (
        <>
          {/* Table Header */}
          <div>
            <table
              className="font-normal w-full overflow-hidden rounded-lg"
              style={{ tableLayout: "fixed" }}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    className="bg-[#78CFEC66] text-sm font-semibold text-start"
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        className="py-3 px-2 text-sm"
                        style={{ width: column.width, textAlign: "left" }} // Ensure left alignment
                      >
                        <div className="flex items-center">
                          {column.render("Header")}
                          <span className="ml-2">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <img
                                  src={Vectorsorting}
                                  style={{ minHeight: 10, minWidth: 10 }}
                                  alt="vector"
                                />
                              ) : (
                                <img
                                  className="rotate-180"
                                  src={Vectorsorting}
                                  alt="vector"
                                />
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
            </table>
          </div>

          {/* Table Body */}
          <div className="scrollbar-none bg-white" style={{ overflowY: "auto", maxHeight: "650px" }}>
            <table
              className="font-normal w-full overflow-hidden rounded-lg"
              style={{ tableLayout: "fixed" }}
            >
              <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300"
                      onClick={() => openOrderList(row.original.id)}
                    >
                      {row.cells.map((cell, index) => (
                        <td
                          key={index}
                          {...cell.getCellProps()}
                          className="p-2 text-[#272728] text-sm font-normal"
                          style={{ width: cell.column.width }} // Ensure consistency with column width
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
                {page.length === 0 && (
                  <tr>
                    <td colSpan={100}>
                      <Empty className="mt-10" description={t("No data available")} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <CustomPagination
            data={data?.length}
            pageIndex={pageIndex}
            pageCount={page?.length}
            canPreviousPage={pageIndex !== 1}
            canNextPage={data?.length === pageSize}
            gotoPage={(page) => nextPage(page)}
            previousPage={() => setpageIndex(pageIndex - 1)}
            nextPage={() => setpageIndex(pageIndex + 1)}
            pageSize={pageSize}
            setPageSize={(size) => setPageSize(size)}
          />
        </>
      )}
    </div>
  );
};

export default AllVendorsTable;
